import { axiosV2, getError, getResponse, settings } from '../../helpers/UtilsHelper';

const { app } = settings;
const { urls } = app?.backend;

export class PromptService {

    static getAll = async ({
        token = '',
        data = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'PromptService - getAll';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.prompts}/`;
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.post({
                url: url,
                data: data,
                headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static createPrompt = async ({
        token = '',
        data = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'PromptService - createPrompt';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.prompts}/`;
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.post({
                url: url,
                data: data,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static getById = async ({
        id = '',
        token = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'PromptService - getById';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.prompts}/${id}`;
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.get({
                url: url,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static deleteById = async ({
        id = '',
        token = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'PromptService - deleteById';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.prompts}/${id}`;
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.delete({
                url: url,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static update = async ({
        id = '',
        token = '',
        data = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'PromptService - update';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.prompts}/${id}`;
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.post({
                url: url,
                data: data,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }
}
